import styled from "styled-components"
import { SPACING } from "../../../../../component-library/design/spacing/spacing.constants"

const PickupTimeGroup = styled.div`
  display: flex;
  margin-top: ${SPACING.S};

  > * {
    width: calc(${100 / 3}% - (${SPACING.S} * 2 / 3));
    margin: 0 ${SPACING.S} 0 0;
  }
`

export { PickupTimeGroup }
